'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TagCloud = require('./TagCloud');

Object.defineProperty(exports, 'TagCloud', {
  enumerable: true,
  get: function get() {
    return _TagCloud.TagCloud;
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tagcloud/lib/index.js
 ** module id = 3549
 ** module chunks = 0
 **/